import React from 'react';
import { Grid, Box, useMediaQuery, Typography  } from '@mui/material';
import LoginComponent from '../Components/LoginComponent';
import ThemeToggleButton from '../Components/SubComponents/ThemeToggleButton';



const Login = () => {
  const isSmallLandscape = useMediaQuery('(max-width: 899px) and (orientation: landscape)');
  const isNarrowVertical = useMediaQuery('(max-width: 727px) and (orientation: portrait)');

  return (
    <>
      <>
      <Typography
        variant="caption"
        sx={{
          position: 'fixed',
          top: 16,
          left: 16,
          zIndex: (theme) => theme.zIndex.tooltip,
          color: 'text.secondary',
        }}
      >
        Developed by: Ænother Team
      </Typography>
      <Typography
        variant="caption"
        sx={{
          position: 'fixed',
          bottom: 16,
          left: { xs: 'auto', sm: 16 },
          right: { xs: 16, sm: 'auto' },
          zIndex: (theme) => theme.zIndex.tooltip,
          color: 'text.secondary',
          textAlign: 'right',
        }}
      >
        V.1.5.6
      </Typography>
      </>
      <Grid
        container
        sx={{
          height: '100vh', // Ocupa toda la altura de la pantalla
          margin: 0,
        }}
      >
        {/* División izquierda: Login */}
        <Grid
          item
          xs={12}
          md={4} // Reduce el tamaño de la parte izquierda
          sx={{
            display: 'flex',
            flexDirection: 'column', // Apilamos los elementos en columna
            alignItems: 'center',
            justifyContent: 'center',
            p: 3,
            height: '100%', // Asegura que ocupe el 100% de la altura
            position: 'relative', // Importante para posicionar el botón relativo a este contenedor
          }}
        >
          {/* Contenido principal: Formulario de Login */}
          <Box
            sx={{
              flex: '0 0 auto', // Evita que el login se expanda o contraiga
              width: '100%', // Ajusta el ancho al contenedor
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <LoginComponent />
          </Box>

          {/* Imagen adicional debajo del Login */}
          <Box
            sx={{
              width: '40%',
              height: 'auto',
              position: 'absolute',
              maxHeight: '100px', // Límite para la altura máxima
              marginTop: 43, // Espaciado entre el login y la imagen
            }}
          >
            <img
              src="https://i.ibb.co/569K345/LOGO-PARQUEADERO.png" 
              alt="Additional Content"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain', // Ajusta para que la imagen no se deforme
                borderRadius: '5%'
              }}
            />
          </Box>

          {/* Botón en la parte inferior izquierda para pantallas pequeñas y horizontales */}
          {(isSmallLandscape || isNarrowVertical) && (
            <Box sx={{ position: 'absolute', bottom: 16, left: 16 }}>
              <ThemeToggleButton />
            </Box>
          )}
        </Grid>

        {/* División derecha: Imagen */}
        <Grid
          item
          xs={12}
          md={8} // Aumenta el tamaño de la parte derecha
          sx={{
            display: { xs: 'none', md: 'flex' }, // Ocultar en pantallas pequeñas
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            overflow: 'hidden', // Evita que la imagen se desborde
            position: 'relative',
          }}
        >
          {/* Botón de tema en la esquina superior derecha */}
          <Box
            sx={{
              position: 'absolute',
              top: { xs: 8, sm: 16, md: 24 },
              right: { xs: 8, sm: 16, md: 24 },
              zIndex: 10,
            }}
          >
            <ThemeToggleButton />
          </Box>

          {/* Imagen de fondo principal */}
          <img
            src="https://i.ibb.co/Ctpyzsp/Parqueadero.jpg"
            alt="Background"
            border="0"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover', // Asegura que la imagen se ajuste correctamente
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Login;
